document.addEventListener("DOMContentLoaded", function () {
    if( location.hash ){
        let hash = location.hash;
        console.log(hash,"hash");

        let tab = document.querySelector('[data-target="' + location.hash + '"]');
        tab.click()
    }
});